import * as angular from 'angular';
import { Decimal } from 'decimal.js';

(function () {
    'use strict';

    /**
     * @ngdoc directive
     * @name pkpDecimalValidator
     * @memberof app
     *
     * @restrict A
     *
     * @description
     * Validator to assure the number of pre-decimal digits and post-decimal digits match with the backend limitations: [19].[8]
     *
     * @attr {PkpUseOriginals} pkpUseOriginals
     *
     * @author rowilken.btc
     */
    angular.module('app').directive('pkpDecimalValidator', pkpDecimalValidator);

    function pkpDecimalValidator(fieldKeyService) {
        return {
            restrict: 'A',
            scope: false,
            require: 'ngModel',
            link: linkFn
        };

        function linkFn(scope, elem, attr, ngModelCtrl) {
            var fieldKey = fieldKeyService.initialize(attr.pkpUseOriginals);

            ngModelCtrl.$validators.pkpDecimalValidator = function (
                modelValue
            ) {
                if (!modelValue || !modelValue[fieldKey.valueKey]) {
                    return true;
                }

                try {
                    var decimalValue = new Decimal(
                        modelValue[fieldKey.valueKey]
                    );
                    var postDecimalDigits = decimalValue.decimalPlaces();
                    var preDecimalDigits =
                        decimalValue.precision() - postDecimalDigits;
                    if (postDecimalDigits > 8 || preDecimalDigits > 19) {
                        return false;
                    }
                } catch (e) {
                    //validation not possible, parsing errors have to be caught elsewhere
                }

                return true;
            };

            attr.$observe('pkpDecimalValidator', function () {
                ngModelCtrl.$validate();
            });
        }
    }
})();
